import {
  CONTROL_FRAME_CHARACTERISTICS,
  FLATNESS_SYMBOL,
  DIMENSION_TYPES,
  MATERIAL_CONDITIONS,
  CYLINDRICITY_SYMBOL,
  PROFILE_OF_A_LINE_SYMBOL,
  PROFILE_OF_A_SURFACE_SYMBOL,
  PERPENDICULARITY_SYMBOL,
  ANGULARITY_SYMBOL,
  POSITION_SYMBOL,
  CONCENTRICITY_SYMBOL,
  RUNOUT_SYMBOL,
  TOTAL_RUNOUT_SYMBOL,
  PARALLELISM_SYMBOL,
  SYMMETRY_SYMBOL,
  CIRCULARITY_SYMBOL,
  STRAIGHTNESS_SYMBOL,
  TOLERANCE_TYPES,
  DEPTH_TYPES,
  ORIENTATIONS,
  ENCLOSURE_SHAPES,
  HANDEDNESS,
  THREAD_SYSTEMS,
} from '@frontend/api';

export const TOLERANCE_TYPE_OPTIONS = [
  { value: TOLERANCE_TYPES.SYMMETRIC, label: 'Symmetric' },
  { value: TOLERANCE_TYPES.ASYMMETRIC, label: 'Asymmetric' },
  { value: TOLERANCE_TYPES.LIMIT, label: 'Limit' },
];

// Reusable options arrays
export const CHARACTERISTIC_OPTIONS = [
  {
    value: FLATNESS_SYMBOL,
    label: `${FLATNESS_SYMBOL} ${CONTROL_FRAME_CHARACTERISTICS[FLATNESS_SYMBOL]}`,
  },
  {
    value: CYLINDRICITY_SYMBOL,
    label: `${CYLINDRICITY_SYMBOL} ${CONTROL_FRAME_CHARACTERISTICS[CYLINDRICITY_SYMBOL]}`,
  },
  {
    value: PROFILE_OF_A_LINE_SYMBOL,
    label: `${PROFILE_OF_A_LINE_SYMBOL} ${CONTROL_FRAME_CHARACTERISTICS[PROFILE_OF_A_LINE_SYMBOL]}`,
  },
  {
    value: PROFILE_OF_A_SURFACE_SYMBOL,
    label: `${PROFILE_OF_A_SURFACE_SYMBOL} ${CONTROL_FRAME_CHARACTERISTICS[PROFILE_OF_A_SURFACE_SYMBOL]}`,
  },
  {
    value: PERPENDICULARITY_SYMBOL,
    label: `${PERPENDICULARITY_SYMBOL} ${CONTROL_FRAME_CHARACTERISTICS[PERPENDICULARITY_SYMBOL]}`,
  },
  {
    value: ANGULARITY_SYMBOL,
    label: `${ANGULARITY_SYMBOL} ${CONTROL_FRAME_CHARACTERISTICS[ANGULARITY_SYMBOL]}`,
  },
  {
    value: POSITION_SYMBOL,
    label: `${POSITION_SYMBOL} ${CONTROL_FRAME_CHARACTERISTICS[POSITION_SYMBOL]}`,
  },
  {
    value: CONCENTRICITY_SYMBOL,
    label: `${CONCENTRICITY_SYMBOL} ${CONTROL_FRAME_CHARACTERISTICS[CONCENTRICITY_SYMBOL]}`,
  },
  {
    value: RUNOUT_SYMBOL,
    label: `${RUNOUT_SYMBOL} ${CONTROL_FRAME_CHARACTERISTICS[RUNOUT_SYMBOL]}`,
  },
  {
    value: TOTAL_RUNOUT_SYMBOL,
    label: `${TOTAL_RUNOUT_SYMBOL} ${CONTROL_FRAME_CHARACTERISTICS[TOTAL_RUNOUT_SYMBOL]}`,
  },
  {
    value: PARALLELISM_SYMBOL,
    label: `${PARALLELISM_SYMBOL} ${CONTROL_FRAME_CHARACTERISTICS[PARALLELISM_SYMBOL]}`,
  },
  {
    value: SYMMETRY_SYMBOL,
    label: `${SYMMETRY_SYMBOL} ${CONTROL_FRAME_CHARACTERISTICS[SYMMETRY_SYMBOL]}`,
  },
  {
    value: CIRCULARITY_SYMBOL,
    label: `${CIRCULARITY_SYMBOL} ${CONTROL_FRAME_CHARACTERISTICS[CIRCULARITY_SYMBOL]}`,
  },
  {
    value: STRAIGHTNESS_SYMBOL,
    label: `${STRAIGHTNESS_SYMBOL} ${CONTROL_FRAME_CHARACTERISTICS[STRAIGHTNESS_SYMBOL]}`,
  },
];

export const DIMENSION_TYPE_OPTIONS = [
  { value: DIMENSION_TYPES.LINEAR, label: 'Linear' },
  { value: DIMENSION_TYPES.ANGULAR, label: 'Angular' },
  { value: DIMENSION_TYPES.DIAMETER, label: 'Diameter' },
  { value: DIMENSION_TYPES.RADIUS, label: 'Radius' },
];

export const MATERIAL_CONDITION_OPTIONS = [
  { value: MATERIAL_CONDITIONS.MMC, label: 'MMC (Maximum Material Condition)' },
  { value: MATERIAL_CONDITIONS.LMC, label: 'LMC (Least Material Condition)' },
];

export const DEPTH_TYPE_OPTIONS = [
  { value: DEPTH_TYPES.THRU, label: 'Through' },
  { value: DEPTH_TYPES.DEPTH, label: 'Depth' },
];

export const ORIENTATION_OPTIONS = [
  { value: ORIENTATIONS.NEAR_SIDE, label: 'Near Side' },
  { value: ORIENTATIONS.FAR_SIDE, label: 'Far Side' },
  { value: ORIENTATIONS.BOTH_SIDES, label: 'Both Sides' },
];

export const ENCLOSURE_SHAPE_OPTIONS = [
  { value: ENCLOSURE_SHAPES.BOX, label: 'Rectangular Box [Basic]' },
  { value: ENCLOSURE_SHAPES.OBROUND, label: 'Obround [Critical to Quality]' },
  { value: ENCLOSURE_SHAPES.PARENTHESES, label: 'Parenthesis [Reference]' },
  { value: ENCLOSURE_SHAPES.CIRCLE, label: 'Circle' },
  { value: ENCLOSURE_SHAPES.PENTAGON, label: 'Pentagon' },
  { value: ENCLOSURE_SHAPES.HEXAGON, label: 'Hexagon' },
  { value: ENCLOSURE_SHAPES.TRIANGLE, label: 'Triangle' },
  { value: ENCLOSURE_SHAPES.OTHER, label: 'Other' },
];

export const HANDEDNESS_OPTIONS = [
  { value: HANDEDNESS.LH, label: 'LH (Left-Hand)' },
  { value: HANDEDNESS.RH, label: 'RH (Right-Hand)' },
];

export const THREAD_SYSTEM_OPTIONS = Object.values(THREAD_SYSTEMS).map(
  (value) => ({
    value,
    label: value.toUpperCase(),
  }),
);
